module.exports = __webpack_public_path__ + "media/images/oficinas/goya1-d124f5572da0d92f722add2e7423e1f4.jpg";